/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import styles from '../TravelCost/travelCost.module.scss';
import HDFCERGO from '../../../../../Assets/images/svg/dar_hdfc_ergo.svg';
import Duration from '../../../../../Assets/images/svg/dar_duration.svg';
import EditIcon from '../../../../../Assets/images/svg/dar_pencil.svg';
import ButtonComponent from '../../../../../Components/Button/button';
import NoDataFound from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import AddIcon from '@mui/icons-material/Add';
import { getCurrencySymbol } from '../../../../../Pages/CostMaster/costMasterUtils';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../../Dashboard/Efforts/scopeDataGrid';
import { v4 as uuidv4 } from 'uuid';
import { AuthContext } from '../../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../../Constants/modules';

const TravelCost = () => {
  const [rows, setRows] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_DETAIL_COMMERCIALS] || []
    : [];

    const hasAccess = (action) => {
      return permission.includes(action);
    };

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [rows]);

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const calculateTotals = () => {
    return rows.reduce(
      (totals, row) => ({
        travelCostDay:
          totals.travelCostDay + (parseFloat(row.travelCostDay) || 0),
        stayCostDay: totals.stayCostDay + (parseFloat(row.stayCostDay) || 0),
        otherCostDay: totals.otherCostDay + (parseFloat(row.otherCostDay) || 0),
      }),
      {
        travelCostDay: 0,
        stayCostDay: 0,
        otherCostDay: 0,
      }
    );
  };

  const getUpdatedRowsWithTotal = (rows) => {
    if (rows.length === 0) {
      return [];
    } else {
      const totals = calculateTotals();
      return [
        ...rows,
        {
          id: '',
          srNo: 'Total Travel Expenses',
          country: '',
          city: '',
          staffCount: '',
          level: '',
          stayDuration: '',
          travelCostDay: totals.travelCostDay.toFixed(2) || 0.0,
          stayCostDay: totals.stayCostDay.toFixed(2) || 0.0,
          otherCostDay: totals.otherCostDay.toFixed(2) || 0.0,
          total: '',
          isTotalRow: true,
        },
      ];
    }
  };
  const filteredRows = searchText
    ? rows.filter((row) =>
        Object.values(row).some((value) =>
          (value ? value.toString() : '').toLowerCase().includes(searchText)
        )
      )
    : rows;

  const updatedRows = getUpdatedRowsWithTotal(filteredRows);

  const handleInputChange = (e, id, field) => {
    const { value } = e.target;
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleSave = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, isEditing: false, isEdit: false } : row
      )
    );
  };

  const handleCancel = (id) => {
    setRows((prevRows) =>
      prevRows.some((row) => row.isEdit)
        ? prevRows.map((row) =>
            row.id === id
              ? { ...row.originalData, isEditing: false, isEdit: false }
              : row
          )
        : prevRows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
              ...row,
              srNo: index + 1,
            }))
    );
  };

  const handleEdit = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? { ...row, isEditing: true, isEdit: true, originalData: { ...row } }
          : row
      )
    );
  };

  const newRowTemplate = {
    country: '',
    city: '',
    staffCount: '',
    level: '',
    stayDuration: '',
    travelCostDay: '',
    stayCostDay: '',
    otherCostDay: '',
    total: '',
  };

  const isRowUnchanged = (row) => {
    return (
      row.city === newRowTemplate.city &&
      row.country === newRowTemplate.country &&
      row.staffCount === newRowTemplate.staffCount &&
      row.level === newRowTemplate.level &&
      row.stayDuration === newRowTemplate.stayDuration &&
      row.travelCostDay === newRowTemplate.travelCostDay &&
      row.stayCostDay === newRowTemplate.stayCostDay &&
      row.otherCostDay === newRowTemplate.otherCostDay &&
      row.total === newRowTemplate.total
    );
  };

  const handleIncrement = (id, field) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: row[field] + 1 } : row
      )
    );
  };

  const handleDecrement = (id, field) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, [field]: Math.max(row[field] - 1, 1) } : row
      )
    );
  };

  const columns = [
    {
      field: 'srNo',
      headerName: 'Sr.No.',
      minWidth: 140,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'country',
      headerName: 'Country',
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div className={styles.dropdown}>
            <select
              value={params.row.country}
              className={styles.textbox}
              onChange={(e) => handleInputChange(e, params.row.id, 'country')}
            >
              <option value="">Select</option>
              <option value="India">India</option>
              <option value="Singapore">Singapore</option>
            </select>
          </div>
        ) : (
          <label className="saved-value">{params.row.country}</label>
        ),
    },
    {
      field: 'city',
      headerName: 'City',
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <select
              value={params.row.city}
              className={styles.textbox}
              onChange={(e) => handleInputChange(e, params.row.id, 'city')}
            >
              <option value="">Select</option>
              <option value="Mumbai">Mumbai</option>
              <option value="Delhi">Delhi</option>
              <option value="Bangalore">Bangalore</option>
            </select>
          </div>
        ) : (
          <label className="saved-value">{params.row.city}</label>
        ),
    },
    {
      field: 'staffCount',
      headerName: 'Staff Count',
      minWidth: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params.row.isEditing ? (
          <div className={styles.counterDiv}>
            <button
              className={styles.counterButtonDec}
              onClick={() => handleDecrement(params.row.id, 'staffCount')}
            >
              –
            </button>
            <input type="text" value={params.row.staffCount} readOnly />
            <button
              className={styles.counterButtonInc}
              onClick={() => handleIncrement(params.row.id, 'staffCount')}
            >
              +
            </button>
          </div>
        ) : (
          <label>{params.row.id === '' ? '' : params.row.staffCount}</label>
        );
      },
    },
    {
      field: 'level',
      headerName: 'Level',
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <select
              value={params.row.level}
              className={styles.textbox}
              onChange={(e) => handleInputChange(e, params.row.id, 'level')}
            >
              <option value="">Select</option>
              <option value="Below Manager">Below Manager</option>
              <option value="Manager and Above">Manager and Above</option>
            </select>
          </div>
        ) : (
          <label className="saved-value">{params.row.level}</label>
        ),
    },
    {
      field: 'stayDuration',
      headerName: 'Stay Duration',
      minWidth: 120,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params.row.isEditing ? (
          <div className={styles.counterDiv}>
            <button
              className={styles.counterButtonDec}
              onClick={() => handleDecrement(params.row.id, 'stayDuration')}
            >
              –
            </button>
            <input type="text" value={params.row.stayDuration} readOnly />
            <button
              className={styles.counterButtonInc}
              onClick={() => handleIncrement(params.row.id, 'stayDuration')}
            >
              +
            </button>
          </div>
        ) : (
          <label>{params.row.id === '' ? '' : params.row.stayDuration}</label>
        );
      },
    },
    {
      field: 'travelCostDay',
      headerName: 'Travel Cost',
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div className={styles.dropdownNTextfield}>
            <select
              value={params.row.currency || 'INR'}
              onChange={(e) => handleInputChange(e, params.row.id, 'currency')}
              className={styles.currencySelect}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
              <option value="AUD">AUD</option>
            </select>
            <span className={styles.line}></span>
            <input
              type="number"
              value={params.row.travelCostDay}
              onChange={(e) =>
                handleInputChange(e, params.row.id, 'travelCostDay')
              }
              className={styles.currencyInput}
            />
          </div>
        ) : (
          <label className="saved-value">
            {getCurrencySymbol(params.row.currency)} {params.row.travelCostDay}
          </label>
        ),
    },
    {
      field: 'stayCostDay',
      headerName: 'Stay Cost',
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div className={styles.dropdownNTextfield}>
            <select
              value={params.row.currency || 'INR'}
              onChange={(e) => handleInputChange(e, params.row.id, 'currency')}
              className={styles.currencySelect}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
              <option value="AUD">AUD</option>
            </select>
            <span className={styles.line}></span>
            <input
              type="number"
              value={params.row.stayCostDay}
              onChange={(e) =>
                handleInputChange(e, params.row.id, 'stayCostDay')
              }
              className={styles.currencyInput}
            />
          </div>
        ) : (
          <label className="saved-value">
            {getCurrencySymbol(params.row.currency)} {params.row.stayCostDay}
          </label>
        ),
    },
    {
      field: 'otherCostDay',
      headerName: 'Other Cost',
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div className={styles.dropdownNTextfield}>
            <select
              value={params.row.currency || 'INR'}
              onChange={(e) => handleInputChange(e, params.row.id, 'currency')}
              className={styles.currencySelect}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
              <option value="AUD">AUD</option>
            </select>
            <span className={styles.line}></span>
            <input
              type="number"
              value={params.row.otherCostDay}
              onChange={(e) =>
                handleInputChange(e, params.row.id, 'otherCostDay')
              }
              className={styles.currencyInput}
            />
          </div>
        ) : (
          <label className="saved-value">
            {getCurrencySymbol(params.row.currency)} {params.row.otherCostDay}
          </label>
        ),
    },
    {
      field: 'total',
      headerName: 'Total',
      minWidth: 140,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <input
            type="text"
            value="₹0.00"
            className={styles.totalValue}
            readOnly
          />
        ) : (
          <span>₹0.00</span>
        ),
    },
    {
      maxWidth: 60,
      headerClassName: styles.actionColumn,
      cellClassName: styles.actionCell,
      renderCell: (params) =>
        params.row.id === '' ? (
          <div></div>
        ) : (
          <div>
          {params.row?.items?.length != 0 ? (
            <div className="mobile-action-icons">
              {!params.row?.isEditing ? (
                <button
                  className="role-action-edit-icon"
                  aria-label="Edit"
                  style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
                        opacity: hasAccess('update') ? 1 : 0.5,
                      }}
                      disabled={!hasAccess('update')}
                      onClick={() => handleEdit(params.row.id)}
                    >
                      <img src={EditIcon} alt="Edit" />
                    </button>
                  ) : (
                    <div className={styles['save-and-cancel-button-main']} style={{ paddingTop: '0px' }}>
                      <button
                        className={styles['save-and-cancel-button'] + ' ' + styles['save-button-tick-placing']}
                        style={{
                          backgroundColor: isRowUnchanged(params.row) ? '#a69df1' : '#6B5CE8', 
                          color: '#ffff',
                        }}
                        onClick={() => handleSave(params.row.id)}
                        disabled={isRowUnchanged(params.row)}
                      >✔</button>
                      <button
                        className={styles['save-and-cancel-button'] + ' ' + styles['save-button-cross-placing']}
                        style={{
                          backgroundColor: 'transparent',
                          color: '#6B5CE8',
                          border: '1px solid #6B5CE8'
                        }}
                        onClick={() => handleCancel(params.row.id)}
                      >X</button>
                    </div>
                 )}
              </div>
              ):null}
              </div>
        ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const handleAddRow = () => {
    const newRow = {
      id: uuidv4(),
      checkbox: false,
      srNo: 1,
      country: '',
      city: '',
      staffCount: 1,
      level: '',
      stayDuration: 1,
      travelCostDay: '',
      stayCostDay: '',
      otherCostDay: '',
      total: '',
      currency: 'INR',
      isEditing: true,
      rowHeight: 120,
    };
    setRows((prevRows) => {
      const updatedRows = [newRow, ...prevRows].map((row, index) => ({
        ...row,
        srNo: index + 1,
      }));
      return updatedRows;
    });
  };

  return (
    <div className={styles.travelCostMainDiv}>
      <div className={styles.travelCcostSummaryDiv1}>
        <span className={styles.summaryTitle}> Travel Cost Summary</span>
        <span className={styles.divider}></span>
        <div className={styles.logoDiv}>
          <div className={styles.imgDiv}>
            <img src={HDFCERGO} className={styles.logoImg} alt="logo" />
          </div>
          <div className={styles.companyInfo}>
            <span className={styles.title}>HDFC Ergo</span>
            <div className={styles.durationDiv}>
              <img src={Duration} alt="Duration" />
              <span>1500 Man Days</span>
            </div>
          </div>
        </div>
        <div className={styles.travelCostDiv}>
          <div className={styles.travelCostHeader}>
            <span>Travel Cost</span>
            <div className={styles.travelCostAmt}>
              <span>00.00</span>
            </div>
          </div>
          <div className={styles.travelCostAmtDiV}></div>
        </div>
      </div>

      <div className={styles.travelCcostSummaryDiv2}>
        <div className={styles.travelCostMain}>
          <span>Travel Cost</span>
          <div className={styles.travelCostSearchAdd}>
            <div className={styles.TravelCostSearch}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="travel-cost-search-input"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
            <ButtonComponent
              variant="contained"
              label="Add"
              onClick={handleAddRow}
              startIcon={<AddIcon />}
              btnCss={styles.addBtn}
              disabled={!hasAccess('create')}
            />
          </div>
        </div>
        <div className={styles.travelCostGrid}>
          <DataGridComponent
            dataRows={updatedRows}
            dataColumns={columns}
            pageSize={10}
            isEdit={setRows}
            sortFilterColumns={[]}
            onRowSelectionChange={() => {}}
            checkboxDisabled={false}
            rowHeight={150}
            noDataImage={NoDataFound}
            noDataTitle="No Travel Cost added yet."
            noDataSubTitle="Please add it to view here"
            hideSeparator={true}
            editStateHeight={110}
            dataGridCss={styles.dataGrid}
          />
        </div>
      </div>
    </div>
  );
};

export default TravelCost;
